import React from 'react';

const Lrn_us_soc = () => {
  return (
    <div>
      
    </div>
  );
}

export default Lrn_us_soc;
